module.exports = __webpack_public_path__ + "assets/img/aww.e77b79cff993c322bcab53f14a4548e0.svg";